//@flow
// /* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */
import { drawLercUtil } from './draw_lerc_util';
import type Painter from "../../render/painter";

export default drawLercOverlay;

function drawLercOverlay(painter: Painter, sourceCache, layer, coords) {
    drawLercUtil(painter, sourceCache, layer, coords,
        {
            programName: 'lerc-overlay',
            bindOtherParamFunc: bindOverlayParam
        }
    );
}
function bindOverlayParam(gl, program, layer, sourceCache, coord) {
    // Overlay å å åæ
    bindMask(gl, program, sourceCache, layer, coord, 1);
    bindMask(gl, program, sourceCache, layer, coord, 2);
    bindMask(gl, program, sourceCache, layer, coord, 3);
    bindMask(gl, program, sourceCache, layer, coord, 4);
    // æåä¸ä¸ªçº¹çååè®©åºæ¥
    // bindMask(gl, program, sourceCache, layer, coord, 5);
}


function bindIncludeAndExclude(gl, program, layer, index) {
    const maskInclude = layer.paint.get(`lerc-mask-include-${index}`) || [];
    const maskExclude = layer.paint.get(`lerc-mask-exclude-${index}`) || [];


    gl.uniform1i(program.uniforms[`u_mask_include_length_${index}`], maskInclude.length);
    gl.uniform1i(program.uniforms[`u_mask_exclude_length_${index}`], maskExclude.length);


    const u_mask_include = gl.getUniformLocation(program.program, `u_mask_include_${index}`);
    const u_mask_exclude = gl.getUniformLocation(program.program, `u_mask_exclude_${index}`);

    if (maskInclude.length > 0 && maskInclude[0]) {
        gl.uniform2fv(u_mask_include, maskInclude.join().split(','));
    }
    if (maskExclude.length > 0 && maskExclude[0]) {
        gl.uniform2fv(u_mask_exclude, maskExclude.join().split(','));
    }
}


function bindMask(gl, program, sourceCache, layer, coord, index) {
    const maskTexture = getLercMaskTexture(sourceCache, layer, coord, index);
    // let uMask = false;
    if (maskTexture !== undefined) {
        gl.uniform1i(program.uniforms[`u_mask_${index}`], true);
        gl.activeTexture(gl.TEXTURE3 + (index - 1));
        gl.bindTexture(gl.TEXTURE_2D, maskTexture);
        gl.uniform1i(program.uniforms[`u_texture_mask_${index}`], 3 + index - 1);
    } else {
        gl.uniform1i(program.uniforms[`u_mask_${index}`], false);
    }
    bindIncludeAndExclude(gl, program, layer, index);
}


function getLercMaskTexture(sourceCache, layer, coord, index) {

    const maskSourceId = layer.paint.get(`lerc-mask-source-${index}`);
    if (!maskSourceId) {
        return undefined;
    }
    const maskSourceCache = sourceCache.style.sourceCaches[maskSourceId];
    if (!maskSourceCache) {
        return undefined;
    }
    const maskTile = maskSourceCache.getTile(coord) || maskSourceCache._cache.get(coord);
    const maskTexture = (maskTile && maskTile.texture);
    if (!maskTexture) {
        return undefined;
    }
    return maskTexture;
}
